// The shared screen kit for module pages (HR, Finance, Dealership). It was built for
// HR and still lives under pages/HR; Finance and DMS import it from here so they do
// not depend on HR's folder. Moving the files themselves is a later, mechanical step.
export { PageHeader, LoadState, EmptyState, Field, Tabs, PrimaryButton, SecondaryButton, DetailGrid } from "../../pages/HR/hrComponents";
export {
  thStyle,
  tdStyle,
  cardStyle,
  labelStyle,
  inputStyle,
  iconBtnStyle,
  pageStyle,
  badgeStyle,
  statusBadge,
  statusLabel,
  formatDate,
  formatDateTime,
  todayYmd,
  useLoad,
} from "../../pages/HR/hrUi";
export { FormFields, FormDrawer, cleanValues, withNulls } from "../../pages/HR/hrForm";
export { default as EmployeeSelect } from "../../pages/HR/EmployeeSelect";
export { default as AppDropdown } from "../AppDropdown/AppDropdown";
export { default as SlidePanel } from "../SlidePanel/SlidePanel";
